<script lang="ts" context="module">
    export type OnSubmitSuccessParams<TValues, TResultData> = {
        form: Form<TValues, string>;
        data: TResultData;
    };

    export type OnSubmitErrorParams<TValues> = {
        form: Form<TValues, string>;
        error: string;
    };
</script>

<script lang="ts" generics="TValues, TResultData extends unknown">
    import type { Result } from '$lib/utils/result.js';
    import * as result from '$lib/utils/result.js';

    import {
        type Form,
        formHasErrors,
        formIsAsyncValidating,
    } from '@jmvdevelop/svelte-form';
    import { getMessageFromError } from '$lib/utils/error';

    let className = '';
    export { className as class };

    export let form: Form<TValues, string>;
    const actions = form.actions();

    export let onSubmit = async (
        _form: Form<TValues, string>,
    ): Promise<Result<TResultData, string>> => {
        return result.fail('error');
    };

    export let onSubmitSuccess = (
        _: OnSubmitSuccessParams<TValues, TResultData>,
    ): void => {};

    export let onSubmitError = (_: OnSubmitErrorParams<TValues>): void => {};

    async function innerOnSubmit(_event: SubmitEvent) {
        form.dispatch(actions.startSubmit);
        form.dispatch(actions.clearSubmitErrors);
        if (formHasErrors(form.getState()) || formIsAsyncValidating(form.getState())) {
            form.dispatch(actions.stopSubmit);
        } else {
            try {
                const res = await onSubmit(form);
                result.tap(
                    res,
                    (data) => {
                        form.dispatch(actions.submitSuccess);
                        form.dispatch(actions.stopSubmit);
                        onSubmitSuccess({ form, data });
                    },
                    (error: string) => {
                        if (typeof error === 'string') {
                            form.dispatch(actions.addSubmitError(error));
                        }
                        form.dispatch(actions.stopSubmit);
                        onSubmitError({ form, error });
                    },
                );
            } catch (error) {
                if (typeof error === 'string') {
                    form.dispatch(actions.addSubmitError(error));
                }
                form.dispatch(actions.stopSubmit);
                onSubmitError({ form, error: getMessageFromError(error) });
            }
        }
    }
</script>

<form class={className} on:submit|preventDefault={innerOnSubmit} method="post">
    <slot />
</form>
